// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"f3def101","656":"02572b66","787":"d6fe38e8"}[chunkId] + ".chunk.js";
};